/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetMyVolunteerShiftSignupsQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type GetMyVolunteerShiftSignupsQuery = {
  myVolunteerShiftSignups: Array<Pick<Types.ShiftSignup, "shift_id">>;
};

export const GetMyVolunteerShiftSignupsDocument = gql`
  query GetMyVolunteerShiftSignups($event_id: Int!) {
    myVolunteerShiftSignups(event_id: $event_id) {
      shift_id
    }
  }
`;

/**
 * __useGetMyVolunteerShiftSignupsQuery__
 *
 * To run a query within a React component, call `useGetMyVolunteerShiftSignupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVolunteerShiftSignupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVolunteerShiftSignupsQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetMyVolunteerShiftSignupsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMyVolunteerShiftSignupsQuery,
    GetMyVolunteerShiftSignupsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetMyVolunteerShiftSignupsQuery,
    GetMyVolunteerShiftSignupsQueryVariables
  >(GetMyVolunteerShiftSignupsDocument, baseOptions);
}
export function useGetMyVolunteerShiftSignupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMyVolunteerShiftSignupsQuery,
    GetMyVolunteerShiftSignupsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetMyVolunteerShiftSignupsQuery,
    GetMyVolunteerShiftSignupsQueryVariables
  >(GetMyVolunteerShiftSignupsDocument, baseOptions);
}
export type GetMyVolunteerShiftSignupsQueryHookResult = ReturnType<
  typeof useGetMyVolunteerShiftSignupsQuery
>;
export type GetMyVolunteerShiftSignupsLazyQueryHookResult = ReturnType<
  typeof useGetMyVolunteerShiftSignupsLazyQuery
>;
export type GetMyVolunteerShiftSignupsQueryResult =
  ApolloReactCommon.QueryResult<
    GetMyVolunteerShiftSignupsQuery,
    GetMyVolunteerShiftSignupsQueryVariables
  >;
